/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from "react";
import "./Products.css";
import productone from "../images/skincare.png";
import producttwo from "../images/emailbackground.png";
import productthree from "../images/uploadbackground.png";
import productfour from "../images/userbackground.png";
import api from "../components/api";
import { useFilter } from "../context/FilterContext";

const Products = () => {
  const [menuOpen1, setMenuOpen1] = useState(false);
  const [menuOpen2, setMenuOpen2] = useState(false);
  const [menuOpen8, setMenuOpen8] = useState(false);
  const [menuOpen4, setMenuOpen4] = useState(false);
  const { filters } = useFilter();

  useEffect(() => {
    const fetchFilteredProducts = async () => {
      const response = await api.get("/v2/products", {
        params: filters,
      });
      // set your product list here
    };

    fetchFilteredProducts();
  }, [filters]);

  const productImages = [productone, producttwo, productthree, productfour];

  const toggleMenu1 = () => {
    setMenuOpen1(!menuOpen1);
  };

  const toggleMenu2 = () => {
    setMenuOpen2(!menuOpen2);
  };

  const toggleMenu8 = () => {
    setMenuOpen8(!menuOpen8);
  };

  const toggleMenu4 = () => {
    setMenuOpen4(!menuOpen4);
  };

  return (
    <div>
      <div className="container">
        <div className="key-frees">
          <p onClick={toggleMenu1}>Key Ingredients</p>
          {menuOpen1 && (
            <div className="collapsible-menu">
              <label htmlFor="key1">
                <input type="checkbox" id="key1" name="key1" />
                AHA
              </label>
              <label htmlFor="key2">
                <input type="checkbox" id="key2" name="key2" />
                BHA
              </label>
              <label htmlFor="key8">
                <input type="checkbox" id="key8" name="key8" />
                Ceramides
              </label>
              <label htmlFor="key4">
                <input type="checkbox" id="key4" name="key4" />
                Hyaluronic Acid
              </label>
              <label htmlFor="key5">
                <input type="checkbox" id="key5" name="key5" />
                Niacinamide (B8)
              </label>
              <label htmlFor="key6">
                <input type="checkbox" id="key6" name="key6" />
                Peptides
              </label>
              <label htmlFor="key7">
                <input type="checkbox" id="key7" name="key7" />
                Prebiotics & Probiotics
              </label>
              <label htmlFor="key8">
                <input type="checkbox" id="key8" name="key8" />
                Retinol
              </label>
              <label htmlFor="key9">
                <input type="checkbox" id="key9" name="key9" />
                Vitamin C
              </label>
              <label htmlFor="key10">
                <input type="checkbox" id="key10" name="key10" />
                Vitamin E
              </label>
            </div>
          )}
          <p onClick={toggleMenu2}>Product claims</p>
          {menuOpen2 && (
            <div className="collapsible-menu">
              <label htmlFor="claim1">
                <input type="checkbox" id="claim1" name="claim1" />
                Non-Comedogenic
              </label>
              <label htmlFor="claim2">
                <input type="checkbox" id="claim2" name="claim2" />
                Organic
              </label>
              <label htmlFor="claim8">
                <input type="checkbox" id="claim8" name="claim8" />
                Pregnancy-safe
              </label>
              <label htmlFor="claim4">
                <input type="checkbox" id="claim4" name="claim4" />
                Vegan
              </label>
            </div>
          )}
          <p onClick={toggleMenu8}>Free-from</p>
          {menuOpen8 && (
            <div className="collapsible-menu">
              <label htmlFor="freefrom1">
                <input type="checkbox" id="freefrom1" name="freefrom1" />
                Alcohol Free
              </label>
              <label htmlFor="freefrom2">
                <input type="checkbox" id="freefrom2" name="freefrom2" />
                Cruelty-free
              </label>
              <label htmlFor="freefrom8">
                <input type="checkbox" id="freefrom8" name="freefrom8" />
                Ethanolomine-free (DEA, TEA, MEA)
              </label>
              <label htmlFor="freefrom4">
                <input type="checkbox" id="freefrom4" name="freefrom4" />
                Formaldehye-free
              </label>
              <label htmlFor="freefrom5">
                <input type="checkbox" id="freefrom5" name="freefrom5" />
                Fragrance-free
              </label>
              <label htmlFor="freefrom6">
                <input type="checkbox" id="freefrom6" name="freefrom6" />
                Gluten-free
              </label>
              <label htmlFor="freefrom7">
                <input type="checkbox" id="freefrom7" name="freefrom7" />
                Mineral Oil-free
              </label>
              <label htmlFor="freefrom8">
                <input type="checkbox" id="freefrom8" name="freefrom8" />
                No Harmful Preservatives
              </label>
              <label htmlFor="freefrom9">
                <input type="checkbox" id="freefrom9" name="freefrom9" />
                No Synthetic Fragrances
              </label>
              <label htmlFor="freefrom10">
                <input type="checkbox" id="freefrom10" name="freefrom10" />
                Oil-free
              </label>
              <label htmlFor="freefrom11">
                <input type="checkbox" id="freefrom11" name="freefrom11" />
                Paraben-free
              </label>
              <label htmlFor="freefrom12">
                <input type="checkbox" id="freefrom12" name="freefrom12" />
                PEG-free
              </label>
              <label htmlFor="freefrom116">
                <input type="checkbox" id="freefrom116" name="freefrom116" />
                Phthalate free
              </label>
              <label htmlFor="freefrom14">
                <input type="checkbox" id="freefrom14" name="freefrom14" />
                Silicone-free
              </label>
              <label htmlFor="freefrom15">
                <input type="checkbox" id="freefrom15" name="freefrom15" />
                Soap-free
              </label>
              <label htmlFor="freefrom16">
                <input type="checkbox" id="freefrom16" name="freefrom16" />
                Sulphate-free (SLS/SLES)
              </label>
              <label htmlFor="freefrom17">
                <input type="checkbox" id="freefrom17" name="freefrom17" />
                Talc-free
              </label>
            </div>
          )}
          <p onClick={toggleMenu4}>Other</p>
          {menuOpen4 && (
            <div className="collapsible-menu">
              <label htmlFor="other1">
                <input type="checkbox" id="other1" name="other1" />
                Australian-made
              </label>
            </div>
          )}

          <div className="buttons-container">
            <span className="clear-button">Clear</span>
            <button className="apply-button">Apply</button>
          </div>
        </div>
        <div className="product-content">
          <h2>All skincare products</h2>
          <div className="product-grid">
            {Array.from({ length: 12 }).map((_, index) => (
              <div key={index} className="product-box">
                <div className="product-main-content">
                  <img
                    src={productImages[index % productImages.length]}
                    alt={`Product ${index + 1}`}
                  />
                </div>
                <div className="product-footer">
                  <span className="brand-name">Brand Name</span>
                  <span className="product-description">
                    Product description
                  </span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Products;
